import React, { useContext, useEffect, useState } from 'react'

import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import Iframe from '../../components/iframe/Iframe'
import { displayMessage } from '../../services/helper';

export default function MonitoryTutorials() {
    const {
        setShowLoading
    } = useContext(GeneralContext)

    const [monitoryUrls, setMonitoryUrls] = useState([])

    useEffect(() => {
        findEnum()
    }, [])

    async function findEnum() {
        setShowLoading(true)
        try {
            const { data } = await api.enums.find('ETutorialsUrls')
            setMonitoryUrls(data?.MONITORY_URLS || [])
        } catch (error) {
            console.log(error)
        } finally {
            setTimeout(() => {
                setShowLoading(false)
            }, 450);
        }
    }
    
    return (
        <>
            <div className='p-3 rounded-3xl text-appian-blue bg-blue-50'>
                <div className='flex text-center text-2xl font-bold justify-center items-center text-appian-blue pb-5'>
                    {displayMessage('MONITORY_TUTORIAL_TITLE')}
                </div>
            {
                monitoryUrls && monitoryUrls.length && monitoryUrls.map((url) => {
                        return (
                            <div className='mb-14 mt-7' key={url}>
                                <Iframe 
                                    url={url}
                                />
                            </div>
                        )
                })
            }
            </div>
        </>
    )
}